import React, { useEffect } from "react";
import YouTube from "react-youtube";
import useGetVideo from "../custom-hooks/useGetVideo";
import { videosGet, videosGetSeries } from "../constants";
import "../assets/styles/components/MovieDetail.scss";
import NoVideo from "./NoVideo";
import Loader from "./Loader";

const Video = (props) => {
  const { data, uri } = props;
  const { video, loading, novideo, getVideo } = useGetVideo(
    uri === "serie" ? `${videosGetSeries(data)}` : `${videosGet(data)}`
  );
  const { key } = video;

  useEffect(() => {
    getVideo();
  }, []);
  const opts = {
    height: "390",
    width: "640",
    playerVars: {
       //https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };
  return (
    <div>
      {loading ? (
        <Loader />
      ) : novideo ? (
        <NoVideo />
      ) : (
        <div className="trailer">
          <YouTube videoId={key} opts={opts} />
        </div>
      )}
    </div>
  );
};

export default Video;
